var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolanaSpinner = function SvgSolanaSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9327 2.05945C16.0833 3.20238 0.918714 20.22 2.06164 40.0694C3.20457 59.9188 20.2222 75.0833 40.0716 73.9404C59.9209 72.7975 75.0855 55.7798 73.9426 35.9305C73.4126 26.7255 69.4686 18.528 63.4114 12.4971",
    stroke: "url(#paint0_linear_19327_72222)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19327_72222",
    x1: 52.7331,
    y1: -24.5103,
    x2: -7.36943,
    y2: 68.5419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
};
export default SvgSolanaSpinner;